<template>
  <el-dialog title="Adicionar Observação" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="50%">
    <el-form ref="form" :model="observacao" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item label="Data/Hora" prop="dataHora">
            <el-input v-model="observacao.dataHora" v-mask="'##/##/#### ##:##'"/>
          </el-form-item>
        </el-col>

        <el-col :span="19">
          <el-form-item label="Usuário">
            <el-input v-model="usuarioLogado.nome" :readonly="true"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="height: 350px;">
        <el-col :span="24" style="height: 100%;">
          <el-form-item label="Descrição" prop="descricao" class="obs-form-item" style="height: 100%;">
            <el-input
              v-model="observacao.descricao"
              type="textarea"
              style="height: 100%"
              class="obs-text-area "
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="success" size="small">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Util from "../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    observacaoSelecionada: Object,
    tipo: String
  },
  data() {
    return {
      validacao: {
        dataHora: [
          { type: "string", required: true, whitespace: true, len: 16, trigger: 'blur' }
        ],
        descricao: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ]
      },
      observacao: {
        dataHora: Util.agora(),
        descricao: ""
      }
    };
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    ...mapState("clientesStore", {
      cliente(state) { return state.clienteSelecionado; }
    }),
    ...mapState("imoveisStore", {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState('vendasStore', {
      venda(state) { return state.vendaSelecionada }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('imoveisStore', [
      'gravarObservacaoImovel'
    ]),
    ...mapActions('clientesStore', [
      'gravarObservacaoCliente'
    ]),
    ...mapActions('vendasStore', [
      'gravarObservacaoVenda'
    ]),
    reset() {
      if(this.observacaoSelecionada != undefined) {
        this.observacao = this.observacaoSelecionada;
      } else {
        this.observacao = {
          dataHora: Util.agora(),
          descricao: ""
        }
      }
      this.$refs['form'].resetFields();
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      console.log(this.tipo);
      switch(this.tipo) {
        case "CLIENTE":
          this.gravarObservacaoDoCliente(this.observacao);
          break;
        case "IMOVEL":
          this.gravarObservacaoDoImovel(this.observacao);
          break;
        case "VENDA":
          this.gravarObservacoesDaVenda(this.observacao);
          break;
      }
    },
    gravarObservacaoDoCliente(payload) {
      payload.cliente = { id: this.cliente.id };

      this.showLoading();
      this.gravarObservacaoCliente(payload)
        .then((resultado) => {
          this.hideLoading();

          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    gravarObservacaoDoImovel(payload) {
      payload.imovel = { id: this.imovel.id };
        
      this.showLoading();
      this.gravarObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gravarObservacoesDaVenda(payload) {
      payload.venda = { id: this.venda.id };

      this.showLoading();
      this.gravarObservacaoVenda(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    fechar() {
      this.reset();
      this.$emit("close");
    }
  }
};
</script>

<style>
.obs-form-item .el-form-item__content {
  height: 100% !important;
}
.obs-text-area .el-textarea__inner,
.obs-text-area .el-textarea__inner:hover,
.obs-text-area .el-textarea__inner:focus {
  height: 100% !important;
}
</style>

